export default __webpack_public_path__ + "static/media/In-White-128.3832219d.webp";